import { Stack, TableCell, TableHead, TableRow } from '@mui/material'
import FilterIcon from 'assets/FilterIcon'
import React, { Dispatch, SetStateAction } from 'react'
import { COLORS } from 'styles/colors'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { COLUMN_WITH_SORTING, TABLE_HEADER_LABELS } from '../constans'
import { SortOrderings } from '../types'

interface YieldTableHeadProps {
	setSortOrder: Dispatch<SetStateAction<SortOrderings>>
	sortOrder: SortOrderings | null
}

export const YieldTableHead = ({
	setSortOrder,
	sortOrder,
}: YieldTableHeadProps) => {
	return (
		<TableHead>
			<TableRow>
				{TABLE_HEADER_LABELS.map((title, index) => {
					const sortKey = COLUMN_WITH_SORTING[title]
					const isFilterable = Boolean(sortKey)

					return (
						<TableCell key={index} align='left'>
							<Stack direction='row' alignItems='center'>
								<TypographySecondary style={{ display: 'inline-block' }}>
									{title.split('\n').map((line, i) => (
										<React.Fragment key={i}>
											{line}
											{i !== title.split('\n').length - 1 && <br />}
										</React.Fragment>
									))}
								</TypographySecondary>
								{isFilterable && (
									<FilterIcon
										onClick={
											isFilterable ? () => setSortOrder(sortKey) : undefined
										}
										color={sortOrder === sortKey ? COLORS.main : undefined}
									/>
								)}
							</Stack>
						</TableCell>
					)
				})}
			</TableRow>
		</TableHead>
	)
}
